module.exports = __webpack_public_path__ + "img/to_shop_en.b8cb3001.png";